module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_11.a42d2936.svg";